import React, { useLayoutEffect, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import LockUnlock from "../App/LockUnlock";
import ConfirmationModal from "../App/ConfirmationModal";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import {
  DownloadClientsDataInExcelWithoutDisplayNone,
  SortTheList,
} from "../Shared/Utility";
import LockUnlockV2 from "../App/LockUnlockV2";

function SystemConfiguration() {
  const globalState = useGlobalState();
  const [showAnimation, setShowAnimation] = useState(false);
  const [objectAdminData, setObjectAdminData] = useState<any>([]);
  const [editMode, setEditMode] = useState(false);
  const [showOrders, setShowOrders] = useState(false);
  const [locked, setLocked] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState(1);
  const [type, setType] = useState(13);

  useEffect(() => {
    getObjectAdminData(0, 0);
  }, [selectedStatus]);

  function getObjectAdminData(add: any, pid: any) {
    let object = {} as any;
    object.type = type;
    object.add = add;
    object.pid = pid;
    object.status = selectedStatus;
    setShowAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetObjectAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          setObjectAdminData(l_response[0]);
          const deepCopy1 = JSON.parse(JSON.stringify(l_response));
          const deepCopy2 = JSON.parse(JSON.stringify(l_response));
          setThisGridListDataWithoutFilters(deepCopy1);
          //setObjectAdminData(deepCopy1[0]);
          setThisGridListData(deepCopy2[0]);
          thisGridListDataRef.current = deepCopy2[0];
        } else {
          console.log("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValue(value: any, index: any, colName: string) {
    let thisobjectAdminData: any = [...thisGridListData];
    thisobjectAdminData[index][colName] = value;
    setObjectAdminData(thisobjectAdminData);
  }
  function updateObjectAdminData(
    typeid: any,
    pid: any,
    colvalue: string,
    colname: any,
    filesdata: any,
  ) {
    let object = {} as any;
    object.type = typeid;
    object.pid = pid;
    object.colname = colname;
    object.colvalue = colvalue;
    object.filesdata = filesdata;
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/UpdateObjectAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          if (
            colname == "del" ||
            colname == "archive" ||
            colname == "undoarchive" ||
            colname == "PTOrderBy" ||
            colname == "Filesdata" ||
            colname == "delicon"
          ) {
            getObjectAdminData(0, 0);
          }
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "del", []);
      }
    }

    if (obj.ID === 100) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "archive", []);
      }
    }

    if (obj.ID === 101) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "undoarchive", []);
      }
    }

    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    //setObjectAdminData(deepCopy[0]);
    setThisGridListData(deepCopy[0]);
    // thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage(); // Called after DOM update but before paint
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSortName")) {
        (document.getElementById("imgSortName") as HTMLInputElement).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

          {objectAdminData && objectAdminData.length > 0 && (
            <ColumnFilterCheckboxList
              DataType={1}
              RefreshFilters={refreshFilters}
              ClearFilters={clearFilters}
              GridData={objectAdminData}
              ColumnName={selectedColumnName}
              ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
              GetFilteredLists={getFilteredLists}
              ReturnAllFilterdLists={{}}
              ClickPosition={clickPosition}
              Orientation={"Center"}
              ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
            />
          )}
        

      {showAnimation && <LoadingAnimation />}

      {/* <div className="page--breadcrumb flex-jsb">
          <a>General Info</a>
        </div> */}

      <div className="flex-d justify-btw mb-10">
        {/* {editMode == false && (
                <select
                  value={selectedStatus}
                  onChange={(e: any) => setSelectedStatus(e.target.value)}
                >
                  <option value="0">All</option>
                  <option value="1">Active</option>
                  <option value="2">Archived</option>
                </select>
              )} */}
        <span></span>
        {editMode == false && (
          <div className="flex-daj flex-gap10">
            <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a>
            {locked == false && (
              <div className="flex-daj btn-start">
                <a
                  onClick={() => getObjectAdminData(1, 0)}
                  className="btn-primary flex-daj"
                >
                  Add New
                </a>
              </div>
            )}
            {/* <a
                    className="flex-d flex-ac flex-jc btn-md no-display"
                    title="Export"
                    onClick={() =>
                      DownloadClientsDataInExcelWithoutDisplayNone(
                        "tbldnexc",
                        "Info",
                      )
                    }
                  >
                    <img src="images/export.svg" width="18" height="18" />
                  </a> */}

            <LockUnlockV2 locked={locked} setLocked={setLocked} />
          </div>
        )}
      </div>

      <div className="flow-auto">
        {editMode == false && (
          <>
            <table className="reuse-table" id="tbldnexc">
              <thead>
                <tr>
                  <th className="td-xxs">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        S.No
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "SystemConfigurationID")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("SystemConfigurationID")}
                          title="Sort By SystemConfigurationID"
                        >
                          <span id="imgSortSystemConfigurationID">
                            <img
                              src="images/none.svg"
                              width="10px"
                              height="13px"
                              alt="B"
                            />
                          </span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Name")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Name")}
                          title="Sort By Name"
                        >
                          <span id="imgSortName">
                            <img
                              src="images/none.svg"
                              width="10px"
                              height="13px"
                              alt="B"
                            />
                          </span>
                        </a>
                      </div>
                    </div>
                  </th>

                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.SystemConfigurationID}</td>
                          <td className="p-all0">
                            <input
                              disabled={locked}
                              value={item.Name}
                              onChange={(e) =>
                                updateValue(e.target.value, index, "Name")
                              }
                              onBlur={(e) =>
                                updateObjectAdminData(
                                  type,
                                  item.PID,
                                  e.target.value,
                                  "Name",
                                  [],
                                )
                              }
                              className="text-left"
                            />
                          </td>
                          <td className="p-all0">
                            <input
                              disabled={locked}
                              value={item.Value}
                              onChange={(e) =>
                                updateValue(e.target.value, index, "Value")
                              }
                              onBlur={(e) =>
                                updateObjectAdminData(
                                  type,
                                  item.PID,
                                  e.target.value,
                                  "Value",
                                  [],
                                )
                              }
                              className="text-left"
                            />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}
export default SystemConfiguration;
